import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      text-align: center;
    `;
  }};
`;

export const ButtonGroup = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      justify-content: space-around;
      gap: ${theme.spacing.md};
      padding: ${theme.spacing.base};

      > a {
        transition: transform 0.2s ease-in-out;
        &:hover {
          transform: translateY(-0.4rem);
        }
      }
    `;
  }};
`;
